/* Debriefs Custom JavaScript
 * All custom JS for db-* snippets and sections goes here.
 * Organized by component. */

/* ==========================================================================
   Shared MutationObserver — single observer on .shopify-section--main-product
   parent. Components register callbacks via window.dbSectionObserver.register().
   ========================================================================== */

window.dbSectionObserver = (function () {
  var callbacks = [];
  var started = false;

  function start() {
    if (started) return;
    var section = document.querySelector('.shopify-section--main-product');
    if (!section || !section.parentNode) return;
    started = true;
    new MutationObserver(function (mutations) {
      callbacks.forEach(function (cb) {
        try { cb(mutations); } catch (e) { /* never break other callbacks */ }
      });
    }).observe(section.parentNode, { childList: true, subtree: true });
  }

  return {
    register: function (cb) {
      callbacks.push(cb);
      start();
    }
  };
})();

window.dbTrack = function (eventName, data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: eventName }, data || {}));
  try {
    if (window.Shopify && window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, data || {});
    }
  } catch (e) { /* never break UI for analytics */ }
};

window.dbCartUtils = (function () {
  function routes() {
    return window.themeVariables && window.themeVariables.routes
      ? window.themeVariables.routes
      : {};
  }

  function rootUrlWithoutSlash() {
    var root = routes().rootUrlWithoutSlash;
    return typeof root === 'string' ? root : '';
  }

  function joinRoot(path) {
    var normalized = path.charAt(0) === '/' ? path : '/' + path;
    return rootUrlWithoutSlash() + normalized;
  }

  function getProductUrl(handle) {
    return joinRoot('/products/' + encodeURIComponent(handle));
  }

  function getCartJsonUrl() {
    var cartUrl = routes().cartUrl;
    return cartUrl ? cartUrl + '.js' : joinRoot('/cart.js');
  }

  function getCartCurrency() {
    return window.themeVariables && window.themeVariables.settings
      ? window.themeVariables.settings.cartCurrency
      : 'USD';
  }

  function getPathnameWithoutRoot(pathname) {
    var root = rootUrlWithoutSlash();
    if (root && pathname.indexOf(root + '/') === 0) {
      return pathname.slice(root.length);
    }
    return pathname;
  }

  function getCurrentProductHandle() {
    var match = getPathnameWithoutRoot(window.location.pathname).match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function itemHandle(item) {
    var raw = item && (item.handle || item.product_handle || item.url || '');
    var match = String(raw).match(/\/products\/([^/?#]+)/);
    return (match ? match[1] : raw || '').toLowerCase();
  }

  function itemTitle(item) {
    return String(
      item && (item.product_title || item.title || (item.product && item.product.title) || '')
    ).toLowerCase();
  }

  function itemProductType(item) {
    return String(
      item && (item.product_type || (item.product && (item.product.type || item.product.product_type)) || '')
    ).toLowerCase();
  }

  function isPackLike(item) {
    var handle = itemHandle(item);
    var type = itemProductType(item);
    return handle.indexOf('pack') !== -1 || type.indexOf('pack') !== -1;
  }

  function isSubscriptionLike(item) {
    var handle = itemHandle(item);
    return Boolean(item && item.selling_plan_allocation) ||
      handle.indexOf('subscription') !== -1;
  }

  function isCoreUnderwearProduct(item) {
    var handle = itemHandle(item);
    return handle === 'trunks' || handle === 'boxer-briefs';
  }

  function isEligibleSinglePairItem(item) {
    return isCoreUnderwearProduct(item) && !isPackLike(item) && !isSubscriptionLike(item);
  }

  function countEligibleUnderwearItems(cartData) {
    if (!cartData || !cartData.items) return 0;

    return cartData.items.reduce(function (sum, item) {
      return isEligibleSinglePairItem(item) ? sum + item.quantity : sum;
    }, 0);
  }

  function cartRequiresShipping(cartData) {
    if (!cartData || !cartData.items) return false;

    return cartData.items.some(function (item) {
      return Boolean(item && item.requires_shipping);
    });
  }

  function getShippableCartTotal(cartData) {
    if (!cartData || !cartData.items) return 0;

    var total = cartData.items.reduce(function (sum, item) {
      return item && item.requires_shipping ? sum + (item.final_line_price || 0) : sum;
    }, 0);

    if (cartData.cart_level_discount_applications) {
      total -= cartData.cart_level_discount_applications.reduce(function (sum, discount) {
        return sum + (discount.total_allocated_amount || 0);
      }, 0);
    }

    return Math.max(total, 0);
  }

  function formatMoneyWithoutTrailingZeros(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: getCartCurrency(),
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return '$' + amount.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    }
  }

  return {
    getProductUrl: getProductUrl,
    getCartJsonUrl: getCartJsonUrl,
    getCurrentProductHandle: getCurrentProductHandle,
    isEligibleSinglePairItem: isEligibleSinglePairItem,
    countEligibleUnderwearItems: countEligibleUnderwearItems,
    cartRequiresShipping: cartRequiresShipping,
    getShippableCartTotal: getShippableCartTotal,
    formatMoneyWithoutTrailingZeros: formatMoneyWithoutTrailingZeros
  };
})();

/* ==========================================================================
   db-product-toggle — Trunks ↔ Boxer Briefs product switcher
   Uses event delegation so the click handler survives DOM swaps.
   All state is module-scoped (single isLoading / cache / current).
   ========================================================================== */

(function () {
  'use strict';

  var isLoading = false;
  var cache = {};
  var current = '';
  var trunksHandle = '';
  var bbHandle = '';

  /* ---- Read handles from DOM ---- */

  function readHandles() {
    var el = document.getElementById('dbProductToggle');
    if (!el) return false;
    trunksHandle = el.dataset.trunksHandle || 'trunks';
    bbHandle = el.dataset.bbHandle || 'boxer-briefs';
    return true;
  }

  function currentHandle() {
    if (!bbHandle) return '';
    var handle = window.dbCartUtils && typeof window.dbCartUtils.getCurrentProductHandle === 'function'
      ? window.dbCartUtils.getCurrentProductHandle()
      : '';
    return handle === bbHandle ? bbHandle : trunksHandle;
  }

  /* ---- 3D viewer visibility ---- */

  function toggle3DViewers(handle) {
    if (window.ThreeDViewers) {
      if (window.ThreeDViewers.boxerBriefs && window.ThreeDViewers.boxerBriefs.closeModal) {
        window.ThreeDViewers.boxerBriefs.closeModal();
      }
      if (window.ThreeDViewers.trunks && window.ThreeDViewers.trunks.closeModal) {
        window.ThreeDViewers.trunks.closeModal();
      }
    }

    document.querySelectorAll('.viewer-container').forEach(function (c) {
      var type = c.getAttribute('data-product');
      var show = (type === 'boxer-briefs' && handle === bbHandle) ||
                 (type === 'trunks' && handle === trunksHandle);

      c.style.display = show ? '' : 'none';
      c.style.opacity = show ? '1' : '0';
      c.style.pointerEvents = show ? 'auto' : 'none';

      var bbBtn = c.querySelector('#trigger3D-bb');
      var trBtn = c.querySelector('#trigger3D-trunks');
      if (bbBtn) bbBtn.style.display = show && type === 'boxer-briefs' ? '' : 'none';
      if (trBtn) trBtn.style.display = show && type === 'trunks' ? '' : 'none';
    });
  }

  function reinit3DViewers() {
    if (window.ThreeDViewers) {
      delete window.ThreeDViewers.boxerBriefs;
      delete window.ThreeDViewers.trunks;
    }

    setTimeout(function () {
      /* Re-execute inline scripts inside .viewer-container so trigger/modal
         event listeners are re-bound after outerHTML replacement. */
      document.querySelectorAll('.viewer-container script').forEach(function (s) {
        if (s.textContent.indexOf('ThreeDViewers') !== -1 ||
            s.textContent.indexOf('trigger3D') !== -1) {
          try {
            var ns = document.createElement('script');
            ns.textContent = s.textContent;
            s.parentNode.insertBefore(ns, s.nextSibling);
          } catch (_) { /* ignore */ }
        }
      });
    }, 150);
  }

  /* ---- DOM helpers ---- */

  function replaceByOuterHTML(selector, doc) {
    var cur = document.querySelector(selector);
    var nxt = doc.querySelector(selector);
    if (cur && nxt) cur.outerHTML = nxt.outerHTML;
  }

  function replaceStickyForm(newDoc) {
    var cur = document.querySelector('product-sticky-form');
    if (!cur) return;
    /* Replace the whole <product-rerender> wrapper so its observe-form
       attribute re-binds to the new product's form ID. Replacing only the
       inner <product-sticky-form> left the wrapper subscribed to the old
       product, causing price/variant desync after toggle. */
    var curWrapper = cur.closest('product-rerender');
    var nxt = newDoc.querySelector('product-sticky-form');
    if (!nxt) return;
    var nxtWrapper = nxt.closest('product-rerender');
    if (curWrapper && nxtWrapper) {
      curWrapper.outerHTML = nxtWrapper.outerHTML;
    } else if (nxt) {
      cur.outerHTML = nxt.outerHTML;
    }
  }

  function syncHeadNode(selector, doc) {
    var nextNode = doc.head && doc.head.querySelector(selector);
    var currentNode = document.head.querySelector(selector);

    if (!nextNode) {
      if (currentNode) currentNode.remove();
      return;
    }

    if (currentNode) {
      currentNode.replaceWith(nextNode.cloneNode(true));
      return;
    }

    document.head.appendChild(nextNode.cloneNode(true));
  }

  function syncHeadMetadata(doc) {
    if (doc.title) document.title = doc.title;

    [
      'link[rel="canonical"]',
      'meta[name="description"]',
      'meta[property="og:title"]',
      'meta[property="og:description"]',
      'meta[property="og:url"]',
      'meta[property="og:image"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]',
      'meta[name="twitter:image"]'
    ].forEach(function (selector) {
      syncHeadNode(selector, doc);
    });
  }

  function syncSeoH1(doc) {
    var newH1 = doc.querySelector('h1.visually-hidden');
    var currentH1 = document.querySelector('h1.visually-hidden');
    if (newH1 && currentH1) {
      currentH1.textContent = newH1.textContent;
    }
  }

  /* ---- Component reinit ---- */

  function reinitComponents() {
    if (window.Shopify && window.Shopify.PaymentButton) {
      setTimeout(function () { window.Shopify.PaymentButton.init(); }, 300);
    }

    if (window.dbProgressBarInit) {
      setTimeout(function () { window.dbProgressBarInit(); }, 200);
    }
  }

  /* ---- JudgeMe review widget update ---- */

  function reinitJudgeMe(doc) {
    var curWidget = document.getElementById('judgeme_product_reviews');
    if (!curWidget) return;

    var newWidget = doc.querySelector('#judgeme_product_reviews');
    if (!newWidget) return;

    /* Full replacement — avoids the partial merge that caused doubled
       "5.0 out of 55.0 out of 5" text when JudgeMe re-populated
       already-populated elements. */
    curWidget.outerHTML = newWidget.outerHTML;

    /* Re-query the freshly inserted widget */
    var freshWidget = document.getElementById('judgeme_product_reviews');
    if (!freshWidget) return;

    /* Update the data script if present */
    var freshBlock = freshWidget.closest('.shopify-app-block') || freshWidget.parentElement;
    if (freshBlock) {
      var curData = freshBlock.querySelector('script.jdgm-review-widget-data');
      var newData = doc.querySelector('script.jdgm-review-widget-data');
      if (curData && newData) curData.textContent = newData.textContent;
    }

    /* Mark as set-up so JudgeMe CSS treats it as initialized */
    freshWidget.classList.add('jdgm--done-setup-widget');

    /* The fetched HTML wraps reviews in .jdgm-legacy-widget-content with
       an inline display:none (JudgeMe's FOUC guard). On normal page load
       the v3 loader removes it; after our AJAX swap we must do it manually. */
    var legacyWrap = freshWidget.querySelector('.jdgm-legacy-widget-content');
    if (legacyWrap) legacyWrap.style.display = '';

    /* Also strip any temp-hiding stylesheets and force-show the inner widget */
    document.querySelectorAll('.jdgm-temp-hiding-style').forEach(function (s) { s.remove(); });
    var revWidg = freshWidget.querySelector('.jdgm-rev-widg');
    if (revWidg) revWidg.style.display = '';

    /* The fetched HTML contains raw server-rendered reviews without
       JudgeMe's post-processing (verified badges, vote buttons, timestamps,
       sort dropdown). customizeReviews() processes any .jdgm-rev that lacks
       .jdgm--done-setup — safe to call repeatedly. */
    if (window.jdgm && typeof window.jdgm.customizeReviews === 'function') {
      try { window.jdgm.customizeReviews(); } catch (e) { /* v3 compat */ }
    }
  }

  /* ---- Analytics ---- */

  function trackToggle(fromHandle, toHandle, settledVariant) {
    window.dbTrack('product_toggle', {
      product_from: fromHandle,
      product_to: toHandle
    });

    /* When a settled variant is available (from variant:changed event),
       use it directly. Otherwise fall back to the DOM data element.
       This ensures analytics reflect the FINAL variant after option
       restoration, not the default variant from the raw HTML swap. */
    if (settledVariant) {
      window.dbTrack('product_toggle_view_item', {
        product_id: settledVariant.product_id || settledVariant.id,
        variant_id: settledVariant.id,
        sku: settledVariant.sku || '',
        product_title: settledVariant.product_title || settledVariant.name || '',
        product_type: settledVariant.product_type || '',
        vendor: settledVariant.vendor || '',
        price: settledVariant.price,
        currency: settledVariant.currency || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartCurrency) || 'AUD',
        handle: toHandle
      });
      return;
    }

    var dataEl = document.querySelector('[data-db-product-data]');
    if (dataEl) {
      try {
        var pd = JSON.parse(dataEl.textContent);
        window.dbTrack('product_toggle_view_item', {
          product_id: pd.id,
          variant_id: pd.variant_id,
          sku: pd.sku,
          product_title: pd.title,
          product_type: pd.type,
          vendor: pd.vendor,
          price: pd.price,
          currency: pd.currency,
          handle: toHandle
        });
      } catch (_) {}
    }
  }

  /* ---- Variant preservation across toggle ---- */

  function normalizeOptionName(str) {
    return String(str || '').trim().toLowerCase();
  }

  /** Read the current option selections from the variant JSON (e.g., {option1: "Black", option2: "L"}).
      Returns [{position: 1, name: "black"}, {position: 2, name: "l"}] or null.
      Names are normalized (trimmed + lowercased) for resilient cross-product matching. */
  function captureCurrentOptions() {
    var script = document.querySelector('variant-picker script[data-variant]');
    if (!script) return null;
    try {
      var variant = JSON.parse(script.textContent);
      var opts = [];
      for (var i = 1; i <= 3; i++) {
        if (variant['option' + i] != null) {
          opts.push({ position: i, name: normalizeOptionName(variant['option' + i]) });
        }
      }
      return opts.length ? opts : null;
    } catch (_) { return null; }
  }

  /** Extract the human-readable option value name from an input's associated label. */
  function getInputOptionName(input) {
    if (!input.id) return '';
    var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!label) return '';
    /* Color swatches store the name in a .visually-hidden span */
    var hidden = label.querySelector('.visually-hidden');
    if (hidden) return hidden.textContent.trim();
    /* Block swatches: first text node holds the value name */
    for (var n = label.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) { /* Node.TEXT_NODE */
        var t = n.textContent.trim();
        if (t) return t;
      }
    }
    return label.textContent.trim();
  }

  /** After DOM swap, find matching inputs on the new product and check them.
      Priority: size options matched first, then color. If a saved option has
      no match on the target product, the first available (non-disabled) input
      for that position is selected as fallback.
      Returns { changed: boolean } — true if a change event was dispatched,
      meaning we must wait for Focal's async variant:changed before unlocking. */
  function applyOptionsAfterSwap(savedOptions) {
    if (!savedOptions || !savedOptions.length) return { changed: false };
    var picker = document.querySelector('variant-picker');
    if (!picker) return { changed: false };
    var formId = picker.getAttribute('form-id');
    var form = document.forms[formId];
    if (!form) return { changed: false };

    /* form.elements includes inputs linked via form= attribute
       (the option inputs are outside the <form> element in Focal) */
    var allInputs = Array.prototype.filter.call(form.elements, function (el) {
      return el.matches('input[data-option-position][type="radio"]');
    });

    /* Build a map of position -> option group name from the DOM.
       Markup: <div class="product-form__option-selector">
                 <span class="product-form__option-name">Size:</span>
                 ... inputs ...
               </div> */
    var positionNames = {};
    allInputs.forEach(function (inp) {
      var pos = inp.getAttribute('data-option-position');
      if (positionNames[pos]) return;
      var selector = inp.closest('.product-form__option-selector');
      var nameSpan = selector && selector.querySelector('.product-form__option-name');
      if (nameSpan) positionNames[pos] = normalizeOptionName(nameSpan.textContent.replace(/:$/, ''));
    });

    /* Sort: size positions first so size is always preserved over color */
    var sorted = savedOptions.slice().sort(function (a, b) {
      var aIsSize = (positionNames[a.position] || '').indexOf('size') !== -1 ? 0 : 1;
      var bIsSize = (positionNames[b.position] || '').indexOf('size') !== -1 ? 0 : 1;
      return aIsSize - bIsSize;
    });

    var needsChange = false;
    var lastChanged = null;

    sorted.forEach(function (opt) {
      var matched = false;
      for (var i = 0; i < allInputs.length; i++) {
        var inp = allInputs[i];
        if (inp.getAttribute('data-option-position') !== String(opt.position)) continue;
        var name = normalizeOptionName(getInputOptionName(inp));
        if (name === opt.name) {
          if (!inp.checked) {
            inp.checked = true;
            needsChange = true;
            lastChanged = inp;
          }
          matched = true;
          break;
        }
      }
      /* Fallback: no match for this position — select first available option */
      if (!matched) {
        for (var j = 0; j < allInputs.length; j++) {
          var fallback = allInputs[j];
          if (fallback.getAttribute('data-option-position') !== String(opt.position)) continue;
          if (fallback.closest('.is-disabled')) continue;
          if (!fallback.checked) {
            fallback.checked = true;
            needsChange = true;
            lastChanged = fallback;
          }
          break;
        }
      }
    });

    if (needsChange && lastChanged) {
      lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
      return { changed: true };
    }
    return { changed: false };
  }

  /* ---- Variant settlement ---- */

  /** Wait for Focal's async variant:changed event after we dispatch a change
      on a radio input. Focal's selectCombination() is async — it fetches
      section HTML from the server before dispatching variant:changed. We must
      not unlock the UI or fire analytics until that event arrives.
      Calls back with the settled variant object (or null on timeout). */
  function waitForVariantSettled(callback) {
    var picker = document.querySelector('variant-picker');
    var formId = picker && picker.getAttribute('form-id');
    if (!formId) { callback(null); return; }

    var settled = false;

    function settle(variant) {
      if (settled) return;
      settled = true;
      document.removeEventListener('variant:changed', onVariantChanged);
      clearTimeout(timer);
      callback(variant || null);
    }

    function onVariantChanged(e) {
      if (e.detail && e.detail.formId === formId) {
        settle(e.detail.variant);
      }
    }

    document.addEventListener('variant:changed', onVariantChanged);
    /* Timeout fallback: unlock after 2s even if variant:changed never fires
       (e.g., Focal's fetch fails or network is very slow) */
    var timer = setTimeout(function () { settle(null); }, 2000);
  }

  /* ---- Content swap ---- */

  function applyContent(html, handle, savedOptions, onSettled) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    /* Replace entire section elements so Focal custom elements re-initialize */
    replaceByOuterHTML('.shopify-section--main-product', doc);
    replaceByOuterHTML('.shopify-section--product-content', doc);

    /* Breadcrumb and sticky form */
    replaceByOuterHTML('.breadcrumb', doc);
    replaceStickyForm(doc);
    syncHeadMetadata(doc);
    syncSeoH1(doc);

    var prev = current;
    current = handle;
    history.replaceState(null, '', window.dbCartUtils.getProductUrl(handle));

    /* Re-read handles from the freshly inserted toggle element */
    readHandles();

    /* Restore the shopper's option selections (color/size) on the new product */
    var result = savedOptions ? applyOptionsAfterSwap(savedOptions) : { changed: false };

    setTimeout(function () { toggle3DViewers(handle); }, 100);
    reinitComponents();
    reinitJudgeMe(doc);
    setTimeout(function () { reinit3DViewers(); }, 200);

    /* If we dispatched a change, wait for Focal's async variant:changed
       before firing analytics or calling onSettled (which unlocks the UI).
       If no change was needed, settle immediately. */
    if (result.changed) {
      waitForVariantSettled(function (settledVariant) {
        trackToggle(prev, handle, settledVariant);
        if (onSettled) onSettled();
      });
    } else {
      trackToggle(prev, handle, null);
      if (onSettled) onSettled();
    }
  }

  function loadProduct(handle) {
    /* Safety-close any open info modal before outerHTML swap */
    var openModal = document.querySelector('.db-info-modal[aria-hidden="false"]');
    if (openModal) openModal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('db-info-modal-open');

    /* Capture current option selections BEFORE the DOM swap destroys them */
    var savedOptions = captureCurrentOptions();

    isLoading = true;
    var toggle = document.getElementById('dbProductToggle');
    if (toggle) toggle.setAttribute('aria-busy', 'true');

    function done() {
      isLoading = false;
      var freshToggle = document.getElementById('dbProductToggle');
      if (freshToggle) freshToggle.removeAttribute('aria-busy');
      preload();
    }

    if (cache[handle]) {
      try {
        applyContent(cache[handle], handle, savedOptions, done);
      } catch (_) {
        window.location.href = window.dbCartUtils.getProductUrl(handle);
        done();
      }
    } else {
      fetch(window.dbCartUtils.getProductUrl(handle))
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          cache[handle] = html;
          try {
            applyContent(html, handle, savedOptions, done);
          } catch (_) {
            window.location.href = window.dbCartUtils.getProductUrl(handle);
            done();
          }
        })
        .catch(function () {
          window.location.href = window.dbCartUtils.getProductUrl(handle);
        });
    }
  }

  /* ---- Preload ---- */

  function preload() {
    if (!current || !trunksHandle || !bbHandle) return;
    var other = current === trunksHandle ? bbHandle : trunksHandle;
    if (cache[other]) return; /* already cached */
    fetch(window.dbCartUtils.getProductUrl(other))
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) { cache[other] = html; })
      .catch(function () { /* silent */ });
  }

  /* ---- Event-delegated click handler (survives DOM swaps) ---- */

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.db-product-toggle__option');
    if (!opt || opt.classList.contains('db-product-toggle__option--active') || isLoading) return;

    var el = document.getElementById('dbProductToggle');
    if (!el) return;

    var next = current === trunksHandle ? bbHandle : trunksHandle;
    loadProduct(next);
  });

  /* ---- Init ---- */

  document.addEventListener('DOMContentLoaded', function () {
    if (readHandles()) {
      current = currentHandle();
      setTimeout(function () { toggle3DViewers(current); }, 500);
      preload();
    }
  });
})();

/* Carousel dots: Using Flickity's native pageDots (configured in product-media.liquid).
   Styled via db-custom.css. No custom JS needed. */

/* ==========================================================================
   db-testimonial — Static featured quote + review grid (no carousel)
   ========================================================================== */

/* ==========================================================================
   db-blog-inline-cta — Inject mid-article callout from <template>
   Clones the template content and places it after the 3rd paragraph
   of the article body. Skips articles with fewer than 3 paragraphs.
   ========================================================================== */

(function () {
  'use strict';

  function injectInlineCTA() {
    var template = document.getElementById('db-blog-inline-cta-template');
    if (!template) return;

    var rte = document.querySelector('.article__content .rte');
    if (!rte) return;

    var paragraphs = rte.querySelectorAll(':scope > p');
    if (paragraphs.length < 3) return;

    /* Injection point: after 3rd <p>, or ~40% through for long articles */
    var insertIndex = paragraphs.length > 10
      ? Math.floor(paragraphs.length * 0.4)
      : 2; /* 0-indexed: index 2 = after 3rd paragraph */

    var target = paragraphs[insertIndex];
    if (!target) return;

    var clone = template.content.cloneNode(true);
    target.after(clone);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectInlineCTA);
  } else {
    injectInlineCTA();
  }
})();

/* ==========================================================================
   db-blog-sticky — Scroll-triggered visibility
   Adds .db-blog-sticky--visible after reader scrolls past 30% of article.
   Uses passive scroll listener for performance, self-removes after trigger.
   ========================================================================== */

(function () {
  'use strict';

  function initStickyScroll() {
    var sticky = document.querySelector('.db-blog-sticky');
    if (!sticky) return;

    function onScroll() {
      var scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPercent >= 0.3) {
        sticky.classList.add('db-blog-sticky--visible');
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyScroll);
  } else {
    initStickyScroll();
  }
})();

/* ==========================================================================
   db-pill-modal — Attribute pill info modal with tabbed content
   Opens from PDP pills [data-db-pill], switches via nav pills inside modal.
   ========================================================================== */

(function () {
  'use strict';

  function setActivePill(modal, index) {
    var heading = modal.querySelector('.db-info-modal__pill-heading');
    var activeBtn = modal.querySelector('.db-info-modal__pill-btn[data-pill-index="' + index + '"]');
    if (heading && activeBtn) heading.textContent = activeBtn.textContent;

    modal.querySelectorAll('.db-info-modal__pill-desc').forEach(function (p) {
      p.hidden = p.getAttribute('data-pill-panel') !== String(index);
    });

    modal.querySelectorAll('.db-info-modal__pill-btn').forEach(function (btn) {
      btn.classList.toggle('db-info-modal__pill-btn--active',
        btn.getAttribute('data-pill-index') === String(index));
    });
  }

  document.addEventListener('click', function (e) {
    var pdpPill = e.target.closest('[data-db-pill]');
    if (pdpPill) {
      var modal = document.getElementById('db-pill-info-modal');
      if (!modal) return;
      setActivePill(modal, pdpPill.getAttribute('data-db-pill'));
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('db-info-modal-open');
      return;
    }

    var navPill = e.target.closest('.db-info-modal__pill-btn');
    if (navPill) {
      var modal = navPill.closest('.db-info-modal');
      if (!modal) return;
      setActivePill(modal, navPill.getAttribute('data-pill-index'));
    }
  });
})();

/* ==========================================================================
   db-info-modal — Open/close via event delegation
   Triggers: [data-db-modal="<id>"] opens modal by ID
   Close:    [data-db-modal-close], backdrop click, or Escape key
   ========================================================================== */

(function () {
  'use strict';

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('db-info-modal-open');
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('db-info-modal-open');
  }

  function closeAny() {
    var open = document.querySelector('.db-info-modal[aria-hidden="false"]');
    if (open) closeModal(open);
  }

  document.addEventListener('click', function (e) {
    /* Open trigger */
    var trigger = e.target.closest('[data-db-modal]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-db-modal'));
      return;
    }

    /* Close button */
    if (e.target.closest('[data-db-modal-close]')) {
      closeModal(e.target.closest('.db-info-modal'));
      return;
    }

    /* Backdrop click (click on .db-info-modal itself, not its children) */
    if (e.target.classList.contains('db-info-modal')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAny();
  });
})();

/* ==========================================================================
   db-blog-analytics — Event delegation + IntersectionObserver
   Tracks clicks on [data-db-track-click] and visibility of [data-db-track-view].
   All events push to dataLayer for GTM (matches existing analytics pattern).
   ========================================================================== */

(function () {
  'use strict';

  function initBlogAnalytics() {
    var articleUrl = window.location.pathname;

    /* --- Click tracking via event delegation --- */
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-db-track-click]');
      if (!el) return;

      var eventName = el.getAttribute('data-db-track-click') + '_click';
      var data = { article_url: articleUrl };

      var product = el.getAttribute('data-db-product');
      if (product) data.product_handle = product;

      window.dbTrack(eventName, data);
    });

    /* --- View tracking via IntersectionObserver --- */
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var eventName = entry.target.getAttribute('data-db-track-view');
        if (eventName) {
          window.dbTrack(eventName + '_view', { article_url: articleUrl });
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    /* Observe all [data-db-track-view] elements */
    document.querySelectorAll('[data-db-track-view]').forEach(function (el) {
      observer.observe(el);
    });

    /* Observe email capture (no data attr — plan says don't modify snippet) */
    var emailEl = document.querySelector('.db-blog-email');
    if (emailEl) {
      emailEl.setAttribute('data-db-track-view', 'blog_email');
      observer.observe(emailEl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogAnalytics);
  } else {
    initBlogAnalytics();
  }
})();

/* ==========================================================================
   db-back-in-stock — Variant availability toggle
   Shows/hides the Klaviyo BIS trigger container based on variant stock.
   Klaviyo's form builder injects its button into .klaviyo-bis-trigger.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('variant:changed', function (e) {
    var bis = document.querySelector('[data-db-bis]');
    if (!bis) return;

    var variant = e.detail ? e.detail.variant : null;
    if (!variant) return;

    bis.classList.toggle('db-back-in-stock--hidden', variant.available);
    if (!variant.available) {
      bis.setAttribute('data-variant-id', variant.id);
    }
  });
})();

/* ==========================================================================
   db-collection-email — Dismissal + analytics
   Hides email bar if dismissed within last 30 days (localStorage).
   Dismiss button uses event delegation.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'db_collection_email_dismissed';
  var EXPIRY_MS = 30 * 24 * 60 * 60 * 1000;

  function isDismissed() {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      if (!val) return false;
      if (Date.now() - parseInt(val, 10) > EXPIRY_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
      }
      return true;
    } catch (e) { return false; }
  }

  function init() {
    var el = document.querySelector('[data-db-collection-email]');
    if (!el) return;

    if (isDismissed()) {
      el.style.display = 'none';
      return;
    }

    window.dbTrack('collection_email_view', {});
  }

  /* Dismiss via event delegation */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-db-collection-email-dismiss]')) return;

    var el = document.querySelector('[data-db-collection-email]');
    if (el) el.style.display = 'none';

    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (err) { /* storage full or blocked */ }

    window.dbTrack('collection_email_dismiss', {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   db-size-guide — Size chart + quiz click tracking
   Event delegation survives toggle DOM swaps.
   ========================================================================== */

(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-size-guide]');
    if (btn) {
      window.dbTrack('size_guide_click', {
        type: btn.getAttribute('data-db-size-guide')
      });
      return;
    }
  });
})();

/* ==========================================================================
   PhotoSwipe zoom fix — Focal caps image w/h at viewport width, preventing
   pinch-to-zoom. Override _buildItems to report full image dimensions.

   ========================================================================== */

(function () {
  'use strict';

  if (!window.customElements) return;

  customElements.whenDefined('product-image-zoom').then(function () {
    var Ctor = customElements.get('product-image-zoom');
    if (!Ctor || !Ctor.prototype._buildItems) return;

    var origBuild = Ctor.prototype._buildItems;

    Ctor.prototype._buildItems = async function () {
      var items = await origBuild.call(this);
      var maxZoom = this.maxSpreadZoom || 2;

      items.forEach(function (item) {
        if (item.originalMedia && item.originalMedia.preview_image) {
          var fullW = Math.min(item.originalMedia.preview_image.width, 3000);
          item.w = fullW;
          item.h = Math.round(fullW / (item.originalMedia.aspect_ratio || 1));
        }
      });

      return items;
    };
  });
})();

/* ==========================================================================
   db-size-recommend — Quiz size recommendation (persistent container)
   The .size-recommendation container lives OUTSIDE <variant-picker> in
   product-form.liquid, so it survives Focal partial rerenders on variant
   change. Only the swatch highlighting needs re-application after DOM swaps.
   Exposed as window.dbRestoreSizeRecommendation for quiz2.js delegation.
   ========================================================================== */

(function () {
  'use strict';

  var LABELS = {
    S: 'Small (28-30")', M: 'Medium (31-34")', L: 'Large (35-38")',
    XL: 'Extra Large (39-43")', XXL: 'Double Extra Large (44-47")'
  };

  function getRecommendedSize() {
    try {
      var raw = localStorage.getItem('underwearFitRecommendation');
      if (!raw) return null;
      return JSON.parse(raw).size;
    } catch (_) { return null; }
  }

  /** Re-apply .block-swatch--recommended class after variant-picker replacement */
  function highlightSwatches(size) {
    document.querySelectorAll('.block-swatch').forEach(function (swatch) {
      var input = swatch.querySelector('input[type="radio"]');
      if (input && input.value === size) {
        if (!swatch.classList.contains('block-swatch--recommended')) {
          swatch.classList.add('block-swatch--recommended');
        }
      }
    });
  }

  /** Fill the persistent .size-recommendation container (outside variant-picker) */
  function populateRecommendation(size) {
    var container = document.querySelector('.size-recommendation');
    if (!container) return;
    var html = 'Your recommended size is: <strong>' + (LABELS[size] || size) + '</strong>';
    if (container.innerHTML === html) return;
    container.innerHTML = html;
    container.style.display = 'block';
  }

  function restoreSizeRecommendation() {
    var size = getRecommendedSize();
    if (!size) return;
    highlightSwatches(size);
    populateRecommendation(size);
  }

  /* Expose globally for quiz2.js delegation */
  window.dbRestoreSizeRecommendation = restoreSizeRecommendation;

  /* Shared observer catches both partial rerenders (variant change) and
     full rerenders (product toggle). Dedup checks inside each function
     prevent redundant DOM writes. */
  window.dbSectionObserver.register(restoreSizeRecommendation);

  /* Init on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreSizeRecommendation);
  } else {
    restoreSizeRecommendation();
  }
})();

/* ==========================================================================
   db-progress-bar — Standard mode tier pricing (survives DOM swaps)
   Re-queries DOM each time instead of caching stale references.
   Cart event listeners on documentElement persist across swaps.
   MutationObserver + variant:changed for re-init after toggle/Focal rerenders.
   ========================================================================== */

(function () {
  'use strict';

  var previousCount = -1;
  var lastMessageHtml = '';

  function readConfig() {
    var bar = document.querySelector('.db-bundle[data-mode="standard"]');
    if (!bar) return null;

    var BASE = Number(bar.dataset.base);
    return {
      bar: bar,
      SYM: bar.dataset.symbol,
      BASE: BASE,
      P1: Number(bar.dataset.p1),
      P3: Number(bar.dataset.p3),
      P6: Number(bar.dataset.p6),
      P9: Number(bar.dataset.p9),
      TIERS: [
        { min: 1, price: Number(bar.dataset.p1), pct: 0 },
        { min: 3, price: Number(bar.dataset.p3), pct: Number(bar.dataset.save3) },
        { min: 6, price: Number(bar.dataset.p6), pct: Number(bar.dataset.save6) },
        { min: 9, price: Number(bar.dataset.p9), pct: Number(bar.dataset.save9) }
      ],
      count: Number(bar.dataset.count) || 0
    };
  }

  function currentTierIndex(count) {
    if (count >= 9) return 3;
    if (count >= 6) return 2;
    if (count >= 3) return 1;
    if (count >= 1) return 0;
    return -1;
  }

  function nextTierIndex(count) {
    if (count >= 9) return -1;
    if (count >= 6) return 3;
    if (count >= 3) return 2;
    if (count >= 1) return 1;
    return 1;
  }

  function setClass(el, cls, on) {
    if (on) { if (!el.classList.contains(cls)) el.classList.add(cls); }
    else    { if (el.classList.contains(cls)) el.classList.remove(cls); }
  }

  function updateTierCards(count, prevCount) {
    /* Re-query to avoid stale refs after DOM swap */
    var cards = document.querySelectorAll('.db-bundle[data-mode="standard"] .db-bundle__tier');
    var curIdx = currentTierIndex(count);
    var nxtIdx = nextTierIndex(count);
    var prevIdx = currentTierIndex(prevCount);

    cards.forEach(function (card, i) {
      var isActive = i === curIdx;
      var isCompleted = curIdx >= 0 && i < curIdx;
      var isNext = i === nxtIdx;
      var isCelebrate = isActive && prevCount >= 0 && curIdx > prevIdx;

      setClass(card, 'db-bundle__tier--active', isActive);
      setClass(card, 'db-bundle__tier--completed', isCompleted);
      setClass(card, 'db-bundle__tier--next', isNext);
      setClass(card, 'db-bundle__tier--celebrate', isCelebrate);
    });
  }

  function updateFill(count) {
    var el = document.getElementById('db-bundle-fill');
    if (!el) return;
    var target = Math.min(count, 9) / 9 * 100 + '%';
    if (el.style.width !== target) el.style.width = target;
  }

  function totalSave(BASE, TIERS, count) {
    var idx = currentTierIndex(count);
    if (idx <= 0) return 0;
    return (BASE - TIERS[idx].price) * count;
  }

  var G = function (v) { return '<span class="db-bundle__green">' + v + '</span>'; };

  function buildMessage(cfg, count, prevCount) {
    var SYM = cfg.SYM;
    var BASE = cfg.BASE;
    var TIERS = cfg.TIERS;
    var P3 = cfg.P3;
    var P9 = cfg.P9;

    /* Static (initial or same count) */
    if (prevCount < 0 || count === prevCount) {
      return messageStatic(SYM, BASE, TIERS, P3, P9, count);
    }
    /* Add */
    if (count > prevCount) {
      return messageOnAdd(SYM, BASE, TIERS, P9, count, prevCount);
    }
    /* Remove */
    return messageOnRemove(SYM, BASE, TIERS, P3, P9, count, prevCount);
  }

  function messageStatic(SYM, BASE, TIERS, P3, P9, count) {
    if (count === 0) {
      return 'Add <strong>3 pairs</strong> to start saving. Mix any sizes & styles';
    }
    var curIdx = currentTierIndex(count);
    if (curIdx === 0) {
      var needed0 = TIERS[1].min - count;
      if (needed0 === 1) return 'You\u2019re <strong>1 pair away</strong> from unlocking ' + G(TIERS[1].pct + '% off') + ' every pair';
      return 'You\u2019re on your way! <strong>' + needed0 + ' more pairs</strong> unlocks ' + G(TIERS[1].pct + '% off') + ' every pair';
    }
    if (curIdx === 3) {
      var total9 = totalSave(BASE, TIERS, count);
      return '<strong>Best value unlocked!</strong> You\u2019re getting ' + G(TIERS[3].pct + '% off') + ' every pair. That\u2019s ' + SYM + total9 + ' off this order';
    }
    var curPct = TIERS[curIdx].pct;
    var nxtIdx = nextTierIndex(count);
    var nxtPct = TIERS[nxtIdx].pct;
    var needed = TIERS[nxtIdx].min - count;
    if (needed === 1) {
      if (nxtIdx === 3) {
        return 'You\u2019re <strong>1 pair away</strong> from <strong>best value</strong> at ' + G(nxtPct + '% off');
      }
      return 'You\u2019re saving ' + G(curPct + '%') + ' per pair. Just <strong>1 more</strong> to unlock ' + G(nxtPct + '% off');
    }
    if (curIdx === 1) {
      return 'You\u2019ve unlocked ' + G(curPct + '% off') + '! Add ' + needed + ' more and you\u2019ll save ' + G(nxtPct + '%');
    }
    if (nxtIdx === 3) {
      return 'You\u2019re saving ' + G(curPct + '% off') + ' every pair! ' + needed + ' more to hit <strong>best value</strong> at ' + G(nxtPct + '% off');
    }
    return 'You\u2019re saving ' + G(curPct + '% off') + '. Add <strong>' + needed + ' more</strong> and you\u2019ll save ' + G(nxtPct + '%');
  }

  function messageOnAdd(SYM, BASE, TIERS, P9, count, prevCount) {
    var curIdx = currentTierIndex(count);
    var prevIdx = currentTierIndex(prevCount);

    /* Tier unlock celebrations */
    if (curIdx > prevIdx && curIdx > 0) {
      if (curIdx === 3) {
        var total9 = totalSave(BASE, TIERS, count);
        return '<strong>Best value unlocked!</strong> You\u2019re getting ' + G(TIERS[3].pct + '% off') + ' every pair. That\u2019s ' + SYM + total9 + ' off this order';
      }
      if (curIdx === 1) {
        return 'You\u2019ve unlocked ' + G(TIERS[1].pct + '% off') + ' on every pair!';
      }
      var nxtIdx = nextTierIndex(count);
      var needed = TIERS[nxtIdx].min - count;
      return 'You\u2019ve unlocked ' + G(TIERS[curIdx].pct + '% off') + '! ' + needed + ' more pairs to hit <strong>best value</strong>';
    }
    /* Pre-discount zone */
    if (curIdx === 0) {
      var needed2 = TIERS[1].min - count;
      if (needed2 === 1) return 'You\u2019re <strong>1 pair away</strong> from unlocking ' + G(TIERS[1].pct + '% off') + ' every pair';
      return 'You\u2019re on your way! <strong>' + needed2 + ' more pairs</strong> unlocks ' + G(TIERS[1].pct + '% off') + ' every pair';
    }
    /* Mid-tier add */
    return messageStatic(SYM, BASE, TIERS, TIERS[1].price, P9, count);
  }

  function messageOnRemove(SYM, BASE, TIERS, P3, P9, count, prevCount) {
    if (count === 0) {
      return 'You\u2019ve lost your bundle savings. Add <strong>3 pairs</strong> to start saving again';
    }
    var curIdx = currentTierIndex(count);
    var prevIdx = currentTierIndex(prevCount);

    /* Dropped a tier */
    if (curIdx < prevIdx) {
      var neededBack = TIERS[prevIdx].min - count;
      return '<span class="db-bundle__loss">Your ' + TIERS[prevIdx].pct + '% discount just slipped away.</span> Add <strong>' + neededBack + ' back</strong> to get it back';
    }
    /* Sitting at tier minimum — warn them */
    if (curIdx > 0 && count === TIERS[curIdx].min) {
      return 'You\u2019re saving ' + G(TIERS[curIdx].pct + '% off') + ' right now. Remove another and you\u2019ll lose it';
    }
    /* Mid-tier remove — reassure, then nudge */
    var nxtIdx = nextTierIndex(count);
    if (nxtIdx >= 0) {
      var needed = TIERS[nxtIdx].min - count;
      if (nxtIdx === 3) {
        return 'You\u2019re still saving ' + G(TIERS[curIdx].pct + '% off') + '. Add <strong>' + needed + ' more</strong> to hit <strong>best value</strong>';
      }
      return 'You\u2019re still saving ' + G(TIERS[curIdx].pct + '% off') + '. Add <strong>' + needed + ' more</strong> and you\u2019ll save ' + G(TIERS[nxtIdx].pct + '%');
    }
    return messageStatic(SYM, BASE, TIERS, P3, P9, count);
  }

  function updateMessage(cfg, count) {
    var el = document.getElementById('db-bundle-message');
    if (!el) return;

    var html = buildMessage(cfg, count, previousCount);
    if (html !== lastMessageHtml) {
      el.innerHTML = html;
      lastMessageHtml = html;
    }

    /* Only animate on actual cart changes (not init/re-render) */
    if (previousCount >= 0 && count !== previousCount) {
      el.style.animation = 'none';
      el.offsetHeight;
      el.style.animation = 'dbFadeIn 0.3s ease-out';
    }
  }

  /* Count only single-pair Trunks/Boxer Briefs (exclude multipacks & subscriptions) */
  function countEligibleItems(cartData) {
    if (!window.dbCartUtils || typeof window.dbCartUtils.countEligibleUnderwearItems !== 'function') {
      return 0;
    }
    return window.dbCartUtils.countEligibleUnderwearItems(cartData);
  }

  function onCartUpdate(cartData) {
    var cfg = readConfig();
    if (!cfg) return;

    var count = countEligibleItems(cartData);
    updateTierCards(count, previousCount);
    setTimeout(function () { updateFill(count); }, 50);
    updateMessage(cfg, count);
    previousCount = count;
  }

  function fetchCart(cb) {
    fetch(window.dbCartUtils.getCartJsonUrl(), { method: 'GET', credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(cb)
      .catch(function () { /* ignore rate-limit or network errors */ });
  }

  function init() {
    var cfg = readConfig();
    if (!cfg) return;
    previousCount = cfg.count;
  }

  /* Re-apply cached JS state to the DOM after Focal rerenders replace
     progress bar HTML with stale cached content. No fetch needed —
     previousCount already holds the correct value. */
  function reapplyState() {
    var cfg = readConfig();
    if (!cfg || previousCount < 0) return;
    var countStr = String(previousCount);
    if (cfg.bar.dataset.count !== countStr) cfg.bar.dataset.count = countStr;
    updateTierCards(previousCount, previousCount);
    updateFill(previousCount);
    var el = document.getElementById('db-bundle-message');
    if (el) {
      var html = buildMessage(cfg, previousCount, -1);
      if (html !== lastMessageHtml) {
        el.innerHTML = html;
        lastMessageHtml = html;
      }
    }
  }

  /* Cart events — the only source of real cart changes */
  document.documentElement.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) { onCartUpdate(e.detail.cart); }
    else { fetchCart(onCartUpdate); }
  });

  document.documentElement.addEventListener('cart:refresh', function (e) {
    if (e.detail && e.detail.cart) { onCartUpdate(e.detail.cart); }
    else { fetchCart(onCartUpdate); }
  });

  /* Variant change / observer recovery — still needed for templates that
     render the progress bar inside a liquid block (pre-order, BFCM).
     On trunks/boxer-briefs the bar is outside the rerender scope so these
     are no-ops (lastMessageHtml guard prevents unnecessary DOM writes).
     Debounced to prevent loop: observer fires from unrelated DOM changes,
     reapplyState touches DOM, which could re-trigger observer. */
  var reapplyTimer = null;
  function debouncedReapply() {
    if (reapplyTimer) return;
    reapplyTimer = setTimeout(function () {
      reapplyTimer = null;
      reapplyState();
    }, 250);
  }

  document.addEventListener('variant:changed', debouncedReapply);

  window.dbSectionObserver.register(debouncedReapply);

  /* Called by product toggle after DOM swap. Immediate best-effort
     correction from JS cache, then fetch real cart for authoritative state.
     Pre-setting previousCount ensures onCartUpdate produces static messaging
     (no misleading add/remove context when the user just toggled products). */
  window.dbProgressBarInit = function () {
    lastMessageHtml = '';
    reapplyState();
    fetchCart(function (cartData) {
      previousCount = countEligibleItems(cartData);
      onCartUpdate(cartData);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   db-cart-trust — keep mini-cart shipping progress reactive to cart events
   even when the drawer body does not fully rerender.
   ========================================================================== */

(function () {
  'use strict';

  function readElements() {
    var root = document.querySelector('.db-cart-trust[data-threshold-enabled="true"]');
    if (!root) return null;

    return {
      root: root,
      shipping: root.querySelector('[data-db-cart-trust-shipping]'),
      message: root.querySelector('[data-db-cart-trust-message]'),
      fill: root.querySelector('[data-db-cart-trust-fill]')
    };
  }

  function update(cartData) {
    var els = readElements();
    if (!els || !els.shipping || !els.message || !els.fill) return;

    var threshold = Number(els.root.dataset.shippingThresholdCents || 0);
    if (!threshold) return;

    var utils = window.dbCartUtils;
    var requiresShipping = utils && typeof utils.cartRequiresShipping === 'function'
      ? utils.cartRequiresShipping(cartData)
      : Boolean(cartData && cartData.requires_shipping);

    els.shipping.hidden = !requiresShipping;
    if (!requiresShipping) return;

    var total = utils && typeof utils.getShippableCartTotal === 'function'
      ? utils.getShippableCartTotal(cartData)
      : 0;
    var remaining = Math.max(threshold - total, 0);
    var progress = Math.min(total / threshold, 1);

    els.fill.style.width = (progress * 100) + '%';
    els.message.classList.toggle('db-cart-trust__shipping-text--success', remaining === 0);

    if (remaining === 0) {
      els.message.innerHTML = 'You\'ve unlocked <strong>free shipping!</strong>';
      return;
    }

    var formattedRemaining = utils && typeof utils.formatMoneyWithoutTrailingZeros === 'function'
      ? utils.formatMoneyWithoutTrailingZeros(remaining)
      : '$' + (remaining / 100).toFixed(2);

    els.message.innerHTML = 'Spend <strong>' + formattedRemaining + '</strong> more for <strong>free shipping</strong>';
  }

  document.documentElement.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) update(e.detail.cart);
  });

  document.documentElement.addEventListener('cart:refresh', function (e) {
    if (e.detail && e.detail.cart) update(e.detail.cart);
  });
})();

/* ==========================================================================
   Fit Quiz — delegated click handler for [data-action="open-fit-quiz"]
   ========================================================================== */

document.addEventListener('click', function (e) {
  if (e.target.closest('[data-action="open-fit-quiz"]')) {
    if (window.fitQuiz && typeof window.fitQuiz.openQuiz === 'function') {
      window.fitQuiz.openQuiz();
    }
  }
});

/* ==========================================================================
   db-image-tap-zoom — Tap product image to open PhotoSwipe lightbox
   Mobile/touch only — on desktop, Focal's click-nav handles left/right
   navigation and the magnifying glass button handles zoom.
   Uses event delegation so handler survives DOM swaps (toggle, variant change).
   Distinguishes tap from drag via pointer position delta.
   ========================================================================== */

(function () {
  'use strict';

  var startX = null;
  var startY = null;
  var DRAG_THRESHOLD = 5;

  /* Only enable on touch devices — desktop uses click-nav + zoom button */
  function isTouchDevice() {
    return window.matchMedia('(pointer: coarse)').matches;
  }

  document.addEventListener('pointerdown', function (e) {
    if (!isTouchDevice()) return;

    var item = e.target.closest('.product__media-item[data-media-type="image"]');
    if (item && item.classList.contains('is-selected')) {
      startX = e.clientX;
      startY = e.clientY;
    }
  });

  document.addEventListener('click', function (e) {
    if (startX == null) return;

    var item = e.target.closest('.product__media-item[data-media-type="image"]');
    if (!item || !item.classList.contains('is-selected')) {
      startX = null;
      return;
    }

    /* Don't double-fire if clicking the zoom button itself */
    if (e.target.closest('.product__zoom-button')) {
      startX = null;
      return;
    }

    var dx = Math.abs(e.clientX - startX);
    var dy = Math.abs(e.clientY - startY);
    startX = null;
    startY = null;

    if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) return;

    var zoomBtn = item.closest('.product__media-list-wrapper').querySelector('.product__zoom-button');
    if (zoomBtn) zoomBtn.click();
  });
})();
